import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import attributes from '../settings/references.json'
import renderers from './customRenderers'

// Note that when adding a language, the language will be automatically
// added to moment, however the locale will not be automatically imported
// for the new language and english will be shown instead.
// Head over to webpack.config.(dev|prod).js and update the momentjs plugin

function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1')
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}

function parse(payload) {
    // Run through all defined languages
    return _.mapValues(attributes.languages, (name, language) => {
        // First we set title and content to the english versions
        let { title, content } = payload.localized.en

        // If the localization doesn't exist, we have the english
        if (payload.localized[language] !== undefined) {
            // Try to add the localized title
            if (payload.localized[language].title !== undefined) {
                title = payload.localized[language].title
            }

            // Try to add the localized content
            if (payload.localized[language].content !== undefined) {
                content = payload.localized[language].content
            }
        }

        // Finally replace the image links
        content = replaceAll(content, 'images.contentful.com', 'webimg.ccpgamescdn.com')

        return {
            title: <ReactMarkdown renderers={renderers} source={title} />,
            content: (
                <div className="notification-message">
                    <ReactMarkdown key={`content_${name}`} renderers={renderers} source={content} />
                    <p key={`timeago_${name}`} className="notification-timeago">
                        {moment(payload.updated)
                            .locale(language)
                            .fromNow()}
                    </p>
                </div>
            ),
        }
    })
}

export default parse



// WEBPACK FOOTER //
// ./src/markdown/parser.js